import { Component, OnInit,Input } from '@angular/core';
import { DatagridOptions } from '../utils/datagrid-options';

@Component({
  selector: 'lib-data-view',
  template: `<!-- <p-dataList [value]="rows">
  <ng-template let-row pTemplate="item">
    <div class="ui-g-12 ui-md-9 car-details">
      <div class="ui-g">
          <div class="ui-g-2 ui-sm-6">Number: </div>
          <div class="ui-g-10 ui-sm-6">{{row.number}}</div>
          <div class="ui-g-2 ui-sm-6">Name: </div>
          <div class="ui-g-10 ui-sm-6">{{row.name}}</div>
      </div>
  </div>
  </ng-template>
</p-dataList> -->


  <p-dataList [value]="rows" [paginator]="paginator" [rows]="rowsperpage">
      <p-header>
          List of Cars
      </p-header>
    <ng-template let-row pTemplate="item" >
      <div class="ui-g ui-fluid car-item">
          <div class="ui-g-12 ui-md-12 car-details">
            <div class="ui-g" style="padding: 2em;border-bottom: 1px solid #d9d9d9">
                <div class="ui-g-2 ui-sm-6" > Model </div>
                <div class="ui-g-10 ui-sm-6">{{row.Model}}</div>
                <div class="ui-g-2 ui-sm-6">Name: </div>
                <div class="ui-g-10 ui-sm-6">{{row.Name}}</div>
                <div class="ui-g-2 ui-sm-6">Description: </div>
                <div class="ui-g-10 ui-sm-6">{{row.Description}}</div>
            </div>
        </div>
      </div>
    </ng-template>
  </p-dataList>
`,
  styles: [``]
})
export class DataViewComponent implements OnInit {

  @Input() options: DatagridOptions;
  rows: any[];
  paginator:boolean;
  rowsperpage:number;
  
  constructor() { }

  ngOnInit() {
    this.rows = this.options.rows;
    this.paginator = this.options.paginator;
    this.rowsperpage= this.options.rowsperpage;
  }

}
